module.exports = function (area) {
    return {
        event: 'BWSAUlogout',
        eventContext: {
            area
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/logout-analytics-mapper.js
 **/